import React from 'react';
import Header from '../components/layout/header';
import Sec1p3 from '../sections/sec1-p3';
import SectionTwoP3 from '../sections/section2-p3';
import SectionThreeP3 from '../sections/section3-p3';
import SectionFourP4 from '../sections/section4-p3';
import LastSec from '../sections/LastSec';
import Footerr from '../components/layout/footer';

const Propertydetails = () => {
    return ( 
        <>
         <Header homeActive="unactive" propertiesActive="active" contactActive="unactive" />
         <Sec1p3 />
         <SectionTwoP3 />
          <SectionThreeP3 />
           <SectionFourP4 />
           <LastSec />
           <Footerr />
        </>
     );
}
 
export default Propertydetails;